package com.vizio.redwolf.dms.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.js.JsExport

@Serializable
@JsExport
sealed class NonceRegisterResponse {
    @Serializable
    class Invalid(
        @SerialName("message") val message: String? = null,
        @SerialName("responseCode") val responseCode: String? = null
    ) : NonceRegisterResponse()

    @Serializable
    @SerialName("pin_registered")
    class RegistrationSuccess(
        @SerialName("deviceId") val deviceId: String? = null,
        @SerialName("deviceInstanceId") val deviceInstanceId: String? = null,
        @SerialName("serialNumber") val serialNumber: String? = null,
        @SerialName("friendlyName") val friendlyName: String? = null
    ) : NonceRegisterResponse() {
        val responseCode: String by lazy {
            @OptIn(kotlinx.serialization.ExperimentalSerializationApi::class)
            serializer().descriptor.serialName
        }
    }

    @Serializable
    @SerialName("invalid_auth_token")
    class InvalidAuth(
        @SerialName("message") val message: String
    ) : NonceRegisterResponse() {
        val responseCode: String by lazy {
            @OptIn(kotlinx.serialization.ExperimentalSerializationApi::class)
            serializer().descriptor.serialName
        }
    }

    @Serializable
    @SerialName("device_does_not_exist")
    class Failed(
        @SerialName("message") val message: String
    ) : NonceRegisterResponse() {
        val responseCode: String by lazy {
            @OptIn(kotlinx.serialization.ExperimentalSerializationApi::class)
            serializer().descriptor.serialName
        }
    }

    @Serializable
    @SerialName("device_name_must_be_unique")
    class DeviceNameMustBeUnique(@SerialName("message") val message: String) : NonceRegisterResponse() {
        val responseCode: String by lazy {
            @OptIn(kotlinx.serialization.ExperimentalSerializationApi::class)
            serializer().descriptor.serialName
        }
    }

    class Error(val exception: Throwable) : NonceRegisterResponse()

    class Timeout(val exception: Throwable) : NonceRegisterResponse()

    fun <R> fold(
        onInvalid: (Invalid: Invalid) -> R,
        onRegistrationSuccess: (RegistrationSuccess: RegistrationSuccess) -> R,
        onInvalidAuth: (InvalidAuth: InvalidAuth) -> R,
        onFailed: (Failed: Failed) -> R,
        onDeviceNameMustBeUnique: (DeviceNameMustBeUnique: DeviceNameMustBeUnique) -> R,
        onError: (Error: Error) -> R,
        onTimeout: (Timeout: Timeout) -> R
    ): R {
        return when (this) {
            is Invalid -> onInvalid(Invalid(this.message, this.responseCode))
            is RegistrationSuccess -> onRegistrationSuccess(RegistrationSuccess(this.deviceId, this.deviceInstanceId, this.serialNumber, this.friendlyName))
            is InvalidAuth -> onInvalidAuth(InvalidAuth(this.message))
            is Failed -> onFailed(Failed(this.message))
            is DeviceNameMustBeUnique -> onDeviceNameMustBeUnique(DeviceNameMustBeUnique(this.message))
            is Error -> onError(Error(this.exception))
            is Timeout -> onTimeout(Timeout(this.exception))
        }
    }
}